var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.previousImage
    ? _c("v-layout", { attrs: { column: "", "align-start": "" } }, [
        _c("img", {
          staticClass: "network-photo",
          attrs: {
            src: _vm.getPhotoWithBase64(_vm.previousImage.image_thumb),
            alt: "photo"
          }
        }),
        _vm._v(" "),
        _c("label", { staticClass: "value-field" }, [_vm._v(_vm._s(_vm.label))])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-679facc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-679facc2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/Forms/_Molecules/NetworkPhotos.vue
// module id = null
// module chunks = 